module.exports = __webpack_public_path__ + "img/placeholder-image.861a9a6f.png";